import { IconPropView, IconView } from './config';
import React from "react";

export const isIconView = (type: IconPropView | React.ReactNode): type is IconPropView => {
  return typeof type === 'string' && IconView.includes(type as IconPropView);
};
